import * as z from "zod/v4";
import { makeReportDateFilterSchema } from "./base-report-date-filter";
import { ReportFilterType } from "./report-filter-type";

export const ApprovalDateFilterSchema = makeReportDateFilterSchema(
  ReportFilterType.RETURN_APPROVAL_DATE,
);

export type ApprovalDateFilter = z.infer<typeof ApprovalDateFilterSchema>;
